module.exports = __webpack_public_path__ + "img/snow.dec108a9.png";